"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _TrialConstants = require("../../constants/TrialConstants");

var _ResultHeaderIllustration = _interopRequireDefault(require("./ResultHeaderIllustration"));

var _ResultSection = _interopRequireDefault(require("./ResultSection"));

var _PageScore = _interopRequireDefault(require("../PageScore"));

var _Subtitle = _interopRequireDefault(require("../Subtitle"));

var _ScoreConstants = _interopRequireDefault(require("../../constants/ScoreConstants"));

var _PerformanceData = _interopRequireDefault(require("../../data/PerformanceData"));

var _ResultCtaBanner = _interopRequireDefault(require("../ResultCtaBanner"));

var _Urls = require("../../util/Urls");

var CTAButton = (0, _react.memo)(function () {
  var lang = window.I18N_MANUAL_LANG;
  var alt = lang !== 'en' ? '-alt' : '';
  var url = lang !== 'en' ? _TrialConstants.LanguageCTALinks[lang] : _TrialConstants.CTA_PERFORMANCE;
  var parsedUtmParams = (0, _Urls.parseUtmParams)();
  return _react.default.createElement(_UILink.default, {
    href: url + "&" + parsedUtmParams,
    external: true
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "results.performance.cta.button" + alt
  }));
});

var PerformancePage = function PerformancePage(_ref) {
  var websiteGrade = _ref.websiteGrade;
  var grade = websiteGrade.get('performanceAudit').get('grade');
  return _react.default.createElement("div", {
    className: "full-page-centered performance-page",
    id: "performance",
    "data-reagan-selector": "performance-page"
  }, _react.default.createElement("div", null, _react.default.createElement("div", {
    className: "wsg-container"
  }, _react.default.createElement(_ResultHeaderIllustration.default, {
    name: "design-manager"
  }), _react.default.createElement(_PageScore.default, {
    score: grade,
    overallScore: _ScoreConstants.default.PERFORMANCE_OVERALL
  }), _react.default.createElement("h3", null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "results.performance.title"
  })), _react.default.createElement(_Subtitle.default, null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "results.performance.description"
  })), _react.default.createElement(_ResultCtaBanner.default, {
    use: "trophy"
  }, _react.default.createElement(_FormattedReactMessage.default, {
    message: "results.performance.cta.info",
    options: {
      ctaButton: _react.default.createElement(CTAButton, null)
    }
  })), _react.default.createElement("div", {
    className: "results-section radial-results-section"
  }, _react.default.createElement(_ResultSection.default, {
    websiteGrade: websiteGrade,
    results: _PerformanceData.default.topResults
  })), _react.default.createElement("div", {
    className: "results-section"
  }, _react.default.createElement(_ResultSection.default, {
    websiteGrade: websiteGrade,
    results: _PerformanceData.default.middleResults
  })), _react.default.createElement("div", {
    className: "results-section bottom-results"
  }, _react.default.createElement(_ResultSection.default, {
    websiteGrade: websiteGrade,
    results: _PerformanceData.default.bottomResults
  })))));
};

var _default = PerformancePage;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/pages/PerformancePage.js
// module id = 304
// module chunks = 0